<script lang="ts">
    //Props
    export let isCustomerTier = false;
    export let isFirstTier = false;
    export let perksLinesCount: number;
    export let hasPointsMultiplier: boolean;
    export let hasReward: boolean;
    export let dataGwSelector: string | undefined = undefined;
</script>

<div
    style="--lines-count: {perksLinesCount}"
    class="gw-rd-vip-tiers-page-widget-card"
    data-gw-selector={dataGwSelector}
    class:gw-rd-vip-tiers-page-widget-card__default-tier={!isCustomerTier &&
        isFirstTier}
    class:gw-rd-vip-tiers-page-widget-card__customer-tier={isCustomerTier}
>
    {#if $$slots.title && $$slots.description}
        <div class="gw-rd-vip-tiers-page-widget-card__header">
            <div class="gw-rd-vip-tiers-page-widget-card__header-title">
                <slot name="title" />
            </div>
            <div class="gw-rd-vip-tiers-page-widget-card__header-description">
                <slot name="description" />
            </div>
        </div>
    {/if}
    <ul
        class="gw-rd-vip-tiers-page-widget-card__list gw-list-reset-default-styles"
    >
        <li class="gw-rd-vip-tiers-page-widget-card__list-item">
            <slot name="goal" />
        </li>
        {#if hasPointsMultiplier}
            <li class="gw-rd-vip-tiers-page-widget-card__list-item">
                <slot name="points-multiplier" />
            </li>
        {/if}
        {#if hasReward}
            <li class="gw-rd-vip-tiers-page-widget-card__list-item">
                <div class="gw-rd-vip-tiers-page-widget-card__list-item-reward">
                    <slot name="reward" />
                </div>
            </li>
        {/if}
        {#if perksLinesCount}
            <li
                class="gw-rd-vip-tiers-page-widget-card__list-item gw-rd-vip-tiers-page-widget-card__list-item--height"
            >
                <div class="gw-rd-vip-tiers-page-widget-card__list-item-perks">
                    <slot name="perks" />
                </div>
            </li>
        {/if}
    </ul>
</div>

<style lang="postcss">
    .gw-rd-vip-tiers-page-widget-card {
        height: 100%;
        display: flex;
        flex-direction: column;
        color: var(--gw-rd-secondary-color);
        line-height: 24px;

        &__default-tier,
        &__customer-tier &__list {
            font-weight: 600;
        }

        &__default-tier &__header,
        &__customer-tier &__header {
            color: var(--gw-rd-white-color);
            background-color: var(--gw-rd-theme__primary-color);

            &-title {
                color: var(--gw-rd-white-color);
            }
        }

        &__header {
            height: 100%;
            padding: var(--gw-rd-space-8) var(--gw-rd-space-6);
            border-radius: var(--gw-rd-border-radius-sm)
                var(--gw-rd-border-radius-sm) 0px 0px;
            background-color: var(
                --gw-rd-vip-tiers-page-widget__theme-primary-color-lighten
            );

            &-title {
                margin-bottom: var(--gw-rd-space-2);
                font-weight: 600;
                color: var(--gw-rd-theme__primary-color);
            }

            &-description {
                font-weight: normal;
            }
        }

        &__list {
            &-item {
                min-height: 72px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: var(--gw-rd-space-8);

                @media screen and (max-width: 460px) {
                    min-height: 96px;
                }

                &-perks {
                    overflow: hidden;
                    text-align: left;
                }

                &--height {
                    min-height: calc(var(--lines-count) * 72px);

                    @media screen and (max-width: 460px) {
                        min-height: calc(var(--lines-count) * 96px);
                    }
                }
            }
        }
    }
</style>
